import * as Sentry from '@sentry/react';

import { captureSentryException } from '../SentryUtils';

export interface OpenRazorPayPaymentGatewayPopupInterface {
  userProfileData: any;
  paymentOrderDetails: any;
  productCode: string;
  productPath: string;
  redirectPath: string;
  requestObject: any;
  values: any;
  onClickCancelOrder: any;
  onSuccessPayment: any;
  productDetails: any;
}

const openRazorPayPaymentGatewayPopup = (
  props: OpenRazorPayPaymentGatewayPopupInterface
) => {
  const {
    userProfileData,
    paymentOrderDetails,
    productCode,
    productPath,
    redirectPath,
    requestObject,
    values,
    onClickCancelOrder,
    onSuccessPayment,
    productDetails
  } = props;

  const { inviteCode } = values;

  new window['Razorpay']({
    key: paymentOrderDetails.razorpayKey, // Enter the Key ID generated from the Dashboard
    amount: paymentOrderDetails.referralDiscountAmount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    currency: paymentOrderDetails.currency,
    name: paymentOrderDetails.companyName,
    description: paymentOrderDetails.companyDescription,
    image: paymentOrderDetails.image,
    order_id: paymentOrderDetails.pgOrderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
    handler: onSuccessPayment(productPath, redirectPath, requestObject),
    prefill: {
      name: userProfileData.name,
      email: userProfileData.email,
      contact: userProfileData.phone
    },
    notes: {
      program_enum: productDetails.productCode,
      program: productCode,
      full_name: userProfileData.name,
      email: userProfileData.email,
      phone: userProfileData.phone,
      occupation: userProfileData.selectedOccupation,
      state_of_residence: userProfileData.currentState,
      gender: userProfileData.selectedGender,
      user_id: userProfileData.userId,
      invitation_code: inviteCode,
      extra_info_based_on_product_config: JSON.stringify({})
    },
    theme: {
      color: '#F37254'
    },
    modal: {
      ondismiss: () => onClickCancelOrder()
    }
  }).open();
};

export const loadRazorPayScript = (
  onSuccess: () => void,
  onFailure: () => void
) => {
  const razorPayScriptId = 'razorpay-checkout-js';
  const existingScript = document.getElementById(razorPayScriptId);

  if (existingScript) {
    onSuccess();
    return;
  }

  const script = document.createElement('script');
  script.defer = true;
  script.id = razorPayScriptId;
  script.src = 'https://checkout.razorpay.com/v1/checkout.js';
  document.body.appendChild(script);

  script.onload = () => {
    onSuccess();
  };

  script.onerror = (error) => {
    script.remove();
    onFailure();
    Sentry.addBreadcrumb({
      type: 'info',
      category: 'loadRazorPayScript',
      message: 'Failed in loading razorpay script',
      data: {
        params: {
          razorPayScriptElement: document.getElementById(razorPayScriptId),
          path: window.location.href
        }
      }
    });
    captureSentryException(new Error('Failed to initialize razorpay script'));
  };
};

export { openRazorPayPaymentGatewayPopup };
